import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { applyPageMetadata, applyStructuredData } from '../utils/seo';

export default function BartenderJobsAustinPage() {
  useEffect(() => {
    const cleanupMeta = applyPageMetadata({
      title: 'Bartender Jobs in Austin, TX | BarsConnect',
      description: 'Explore bartender jobs, event gigs, and bar shifts in Austin, Texas. Build your free profile on BarsConnect.',
      canonicalUrl: 'https://barsconnect.com/bartender-jobs-austin-tx',
      robots: 'index,follow',
    });

    const cleanupSchema = applyStructuredData([
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://barsconnect.com/' },
          { '@type': 'ListItem', position: 2, name: 'Bartender Jobs', item: 'https://barsconnect.com/bartender-jobs' },
          { '@type': 'ListItem', position: 3, name: 'Austin, TX', item: 'https://barsconnect.com/bartender-jobs-austin-tx' },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'JobPosting',
        title: 'Bartender Jobs in Austin, TX',
        description: 'Flexible bartender opportunities in Austin, TX via BarsConnect.',
        employmentType: 'CONTRACTOR',
        hiringOrganization: {
          '@type': 'Organization',
          name: 'BarsConnect Partner Bars',
          sameAs: 'https://barsconnect.com',
        },
        jobLocation: {
          '@type': 'Place',
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Austin',
            addressRegion: 'TX',
            addressCountry: 'US',
          },
        },
      },
    ]);

    return () => {
      cleanupMeta();
      cleanupSchema();
    };
  }, []);

  return (
    <div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8" data-testid="austin-landing-page">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-white mb-3">Bartender Jobs in Austin, TX</h1>
        <p className="text-muted-foreground mb-8">
          Discover flexible bar shifts, event gigs, and direct bar connections in Austin.
        </p>
        <Card className="bg-white/5 border border-white/10">
          <CardContent className="p-6">
            <p className="text-sm text-muted-foreground mb-4">City-specific opportunities are expanding. Build your free profile now to get discovered first.</p>
            <div className="flex flex-wrap gap-3">
              <Button asChild><Link to="/register/bartenders">Create Free Bartender Profile</Link></Button>
              <Button asChild variant="outline"><Link to="/bartenders">Browse Bartenders</Link></Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
